@if (isExpandable()) {
    <div class="json-node">
        <button class="json-node__toggle" (click)="toggle()">
            <i class="pi" [class.pi-chevron-right]="collapsed()" [class.pi-chevron-down]="!collapsed()"></i>
            @if (keyLabel() !== null) {
                <span class="json-node__key">{{ keyLabel() }}:</span>
            }
            <span class="json-node__summary">{{ summary() }}</span>
        </button>
        @if (!collapsed()) {
            <div class="json-node__children">
                @for (entry of entries(); track entry[0]) {
                    <app-json-tree [value]="entry[1]" [keyLabel]="entry[0]" [depth]="depth() + 1" />
                }
            </div>
        }
    </div>
} @else {
    <div class="json-node json-node--leaf">
        @if (keyLabel() !== null) {
            <span class="json-node__key">{{ keyLabel() }}:</span>
        }
        <span class="json-node__value" [class]="valueClass()">{{ formattedValue() }}</span>
    </div>
}
